var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrosionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_124",
    "data-name": "Group 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 140,
    height: 140,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M70,0A70,70,0,1,1,0,70,70,70,0,0,1,70,0",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M32.948,110.844H89.94c.326,0,.424-.106.424-.462V94.049c0-.355-.1-.462-.424-.462H58.262c-.12,5.87-5.28,8.815-9.476,6.781a5.485,5.485,0,0,1-.991-.614,6.043,6.043,0,0,1-1.575-1.675,7.251,7.251,0,0,1-1.251-4.492H32.948Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M55.151,50.441c2.392,0,8.029.837,10.606.925,2.669.092,7.662.769,10.6.927,2,.108,5.606.492,7.8.745l13.414,1.1a9.424,9.424,0,0,0,8.481-4.935c1.088-2.028.993-3.318.993-5.542a9.52,9.52,0,0,0-2.521-5.573c-4.316-3.745-6.6-2.891-12.164-3.542-2.857-.334-8.033-.63-10.666-1.013-1.652-.24-5.219-.424-7.053-.636-.624-.072-1.333-.126-1.828-.167-.7-.058-1.266-.131-1.83-.161-1.208-.065-2.424-.281-3.533-.314-2.9-.08-8.369-.921-10.889-.921,0-2.466-2.312-2.592-3.159-1.6-.719.847-.556,4.01-.719,5.228-.3,2.222-.511,8.735-.849,11.247-.178,1.325-.134,2.513-.311,3.836a1.822,1.822,0,0,0,2.928,1.789c.455-.388.449-.84.695-1.4M91.071,44.9l-12.452-.149c-.783-.011-.9-.155-1.684-.165-.658-.01-1.331.006-1.988.009-.868,0-1.1-.139-1.83-.163-.644-.02-1.342,0-1.987.007-1.9.012-5.347-.312-7.351-.309-2.6,0-4.921-.155-7.638-.155,0-1.316.567-6.376.567-7.858l16.522,1.41c1.833.215,8.713.865,10.063.9L98.147,39.66c.9.17-.062,3.025-1.131,3.853-1.266.979-3.761,1.382-5.945,1.382",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M44.828,76.945c0,9.681,12.688,10.236,13.521.555.21-2.464-3.046-9.262-4.3-11.525-.849-1.529-1.485-2.9-2.431-4.439-.552.441-2.424,4.339-2.943,5.27-.366.657-.566,1.236-.935,1.908l-1.72,3.826a14.958,14.958,0,0,0-1.19,4.4",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrosionIcon);
export default __webpack_public_path__ + "static/media/corrosion-icon.e364de7537532e88b3d5e81616cca733.svg";
export { ForwardRef as ReactComponent };